export enum ProductsUuid {
	ANALYSES_UUID_BC = '0c57347c-c52d-45d3-a7ee-bf2300c0b9cd',
	RESULTS_REVIEW_UUID_BC = '25965d7b-098b-4254-8135-00992a312fd7',
	CRYO_5_UUID_BC = 'a07809d3-7dab-43f8-b1cb-2b1c26e7a89d',
	CRYO_5_TOMORROW_UUID_BC = 'b3a00c60-a504-4454-a842-2266fcd2d2e7',
	FREE_CRYO_SUBSCRIPTION_BC = '33112cd3-905a-4677-b5dc-de40ad344af8',
	CRYO_LIFETIME_UUID_BC = 'd168091a-8c53-419c-a613-aec6074df0d5',
	DNA_UUID_BC = 'e0a1aa9c-5597-4203-9760-5d354f002864',
	COQ10_UUID_BC = '3F22169E-7EDA-49DF-AC06-A1476FEE261D',
	MALE_FERTILITY_SUPPLEMENT_UUID_BC = '5d0b2e36-cf04-4f19-83a3-a66354cb8e7d',
	/** Sold as monthly cryostorage until that term was discontinued and its subscribers moved to yearly. */
	CRYO_YEARLY_FROM_MONTHLY_UUID_BC = 'dc7258dc-69bf-4122-ab16-97aa20ef707f',
	CRYO_YEARLY_UUID_BC = '8ed3cfcf-2cfe-4fa6-973f-107d6b6906ca',
	CRYO_TEN_YEARS_UUID_BC = '35a39b22-50f8-4891-bb27-1131fcc9a9fa',
	FERTILITY_SUPLEMENTS_UUID_BC = '8f53623c-28eb-42e0-bac8-e2aea26236d4',
	WITHDRAWAL_CRYOSHIPPING_UUID_BC = '538ee8dc-7115-4b0d-91de-4a41777d5b5b',
	FERTILITY_CONSULTATION_UUID_BC = '626c107c-2917-4345-8287-2dca7522ef1c',
	STI_UUID_BC = '803e90aa-52d5-4cc3-9685-6f81fe9fdd29',
	BUFFER_MEDIA_REPLACEMENT_BC = '5d6bf3ca-f8b0-476d-ac25-ca5755ca7d05',
	PAID_BUFFER_MEDIA_REPLACEMENT_VENUS = 'c63eb782-dc46-4772-a3e3-a19db050554e',
	FREE_BUFFER_MEDIA_REPLACEMENT_VENUS = '263378ce-244b-41ac-968f-f39f9620e06e',
	WITHDRAWAL_DOMESTIC_VENUS = '0d9eb26f-080c-449a-8ae9-cb52c9dd4f99',
	WITHDRAWAL_DOMESTIC_CLIENT_COORDINATED_VENUS = 'c0c35518-cac6-450e-9946-508e3c90902a',
	WITHDRAWAL_INTERNATIONAL_VENUS = '126303ab-dced-4878-9883-78bbf33dc75a',
	STANDARD_SEMEN_ANALYSIS_VENUS = '9eb77c79-f602-462b-8b88-3c90a16af345',
	POST_VASECTOMY_ANALYSIS_VENUS = '75144e73-f827-45cc-af03-6e9535ef8ca1',
}
